<template>
  <ExternalList
      endpoint="/api/v2/time-based-ad-formats"
      :endpoint-filters="{time_based_subchannel_id: timeBasedSubchannel.id}"
      :headlines=" [{width: 10, text: 'Name'}, {width: 10, text: 'Price Per Day'}]"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="timeBasedAdFormat => $router.push(getUrl(timeBasedAdFormat))"
  >
    <template v-slot:default="{ row: timeBasedAdFormat }">
      <td>
        <router-link :to="getUrl(timeBasedAdFormat)">
          {{ timeBasedAdFormat.attributes.name }}
        </router-link>
      </td>

      <td>
          {{ timeBasedAdFormat.attributes.price_per_day | price }}
      </td>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: { ExternalList},

  props: {
    portal: {
      required: true
    },

    timeBasedChannel: {
      required: true
    },

    timeBasedSubchannel: {
      required: true
    }
  },

  methods: {
    getUrl(timeBasedAdFormat) {
      return '/portals/' + this.portal.id + '/time-based-channels/' + this.timeBasedChannel.id + '/time-based-subchannels/' + this.timeBasedSubchannel.id + '/ad-formats/' + timeBasedAdFormat.id
    }
  }
}
</script>
